const AcceptedIcon = () => {
    return (
  <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_525_5678)">
  <path d="M23.4628 0H24.7581C37.6783 0.421097 47.7734 10.6546 48.2331 23.4863V24.7345C47.8129 37.6906 37.5474 47.828 24.6526 48.2331H23.5221C17.3868 47.9882 12.1126 45.8265 7.6994 41.748C2.92036 37.3326 0.28921 31.3506 0 24.8174V23.475C0.482331 10.6226 10.5453 0.444649 23.4628 0ZM23.8123 31.5135C27.9052 27.4602 31.9805 23.3893 36.0382 19.3008C36.6675 18.6677 37.0641 18.0959 36.9021 17.2452C36.5884 15.6004 34.6336 15.0323 33.4513 16.2137C29.5996 20.0623 25.7463 23.9124 21.8914 27.7642C21.8682 27.7874 21.8449 27.7874 21.8217 27.7642C20.1398 26.0898 18.4601 24.4139 16.7827 22.7364C15.1746 21.1274 12.5642 22.9098 13.5062 24.9512C13.6079 25.1723 13.8108 25.4348 14.1148 25.7388C16.1446 27.7692 18.1744 29.7993 20.2042 31.8291C20.5107 32.135 20.7767 32.3419 21.0021 32.4499C21.8905 32.8748 22.7619 32.6176 23.4326 31.9026C23.5563 31.7707 23.6829 31.641 23.8123 31.5135Z" fill="#34C18C"/>
  </g>
  <defs>
  <clipPath id="clip0_525_5678">
  <rect width="48.2331" height="48.2331" fill="white"/>
  </clipPath>
  </defs>
  </svg>
    )
  }
  
  export default AcceptedIcon